import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@emburse/embark-core';
import { useContext } from 'react';
import { useTranslation, $t } from '../../../../hooks/useTranslation';
import { CreateExpenseReportContext } from '../../utils/CreateExpenseReportContext';
function CreateExpenseReportHeading() {
    useTranslation();
    const { stepNumber } = useContext(CreateExpenseReportContext);
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", component: "h1", gutterBottom: true, children: $t('Create a New Expense Report') }), _jsx(Typography, { variant: "body1", component: "p", children: stepNumber === 2
                    ? $t('Please provide the details for the expense report')
                    : $t('What would you like to do?') })] }));
}
export default CreateExpenseReportHeading;
